import { SectionSpacer } from '~/ui-rocco/pages/home-page/components/SectionSpacer';
import { EditorialClosing } from '~/ui-rocco/pages/detail-shared';
import { ProfessionalContactConnectSection } from './sections/ProfessionalContactConnectSection';
import { ProfessionalContactLocationSection } from './sections/ProfessionalContactLocationSection';

/**
 * BC-4572 — revamped professional Contact tab (/contact).
 *
 * Same editorial shell as the other revamped tabs (hero, dark sub-nav, the
 * About-ArchiPro closing) with the dark "Let's connect" intro + the map +
 * enquiry location section as the body. The dark sections sit flush, so the
 * sub-nav and the body share the dark background with no spacer between them.
 * Rendered behind the revamp flag; the route serves overview + contact data so
 * the hero, map and form all resolve.
 */
export const ProfessionalContactPageRevamp = () => {
    return (
        <main
            id="main-content"
            data-testid="professional-contact-page-revamp"
            className="bg-white"
        >
            <ProfessionalContactConnectSection />
            <ProfessionalContactLocationSection />
            <SectionSpacer
                height={160}
                mobileHeight={56}
                className="bg-[#181818]"
                unit="rem"
            />
            <EditorialClosing hideHero />
        </main>
    );
};
